import { $authHost } from ".."
import { getStartParamsQuery } from "../../helpers/api/apiHelper"

export const addWriteOffActAPI = async (writeOffAct) => {
    const {data} = await $authHost.post(`api/write_off_acts/`, writeOffAct)
    return data
}

export const editWriteOfActNumberBasAPI = async (writeOffAct) => {
    const {data} = await $authHost.post(`api/write_off_acts/${writeOffAct.id}/number_bas`, writeOffAct)
    return data
}

export const getWriteOffActAPI = async ({ writeOffActId }) => {
    const {data} = await $authHost.get(`api/write_off_acts/${writeOffActId}`)
    return data
}

export const getWriteOffActFileAPI = async ({ writeOffActId }) => {
    const {data} = await $authHost.get(`api/write_off_acts/file_act/${writeOffActId}`)
    return data
}

export const getWriteOffActsAPI = async ({ offset, limit, query, status, departmentId, agreeDirector, agreeAccountant }) => {

    let params = ''
    if (query) {
        params = `${getStartParamsQuery({ params })}query=${query}`
    }
    
    if ((offset || offset === 0) && limit) {
        params += `${getStartParamsQuery({ params })}offset=${offset}&limit=${limit}`
    }

    if (status) {
        params += `${getStartParamsQuery({ params })}status=${status}`
    }

    if (departmentId) {
        params += `${getStartParamsQuery({ params })}departmentId=${departmentId}`
    }

    if (agreeDirector) {
        params += `${getStartParamsQuery({ params })}agreeDirector=${agreeDirector}`
    }

    if (agreeAccountant) {
        params += `${getStartParamsQuery({ params })}agreeAccountant=${agreeAccountant}`
    }

    const {data} = await $authHost.get(`api/write_off_acts/${params}`)
    return data
}

export const getPositionsForWriteOffAPI = async ({ departmentId, offset, limit, query }) => {

    let params = ''
    if (query) {
        params = `${getStartParamsQuery({ params })}query=${query}`
    }
    
    if ((offset || offset === 0) && limit) {
        params += `${getStartParamsQuery({ params })}offset=${offset}&limit=${limit}`
    }

    if (departmentId) {
        params += `${getStartParamsQuery({ params })}departmentId=${departmentId}`
    }

    const {data} = await $authHost.get(`api/write_off_acts/positions/${params}`)
    return data
}